<template>
  <div class="form login">
    <!-- 验证码 -->
    <el-form>
      <el-row>
        <el-col>
          <el-form-item>
            <el-input
              placeholder="请输入您的手机号"
              @blur="phonea"
              v-model="shuru.phone"
              :suffix-icon="yzmIcon"
            ></el-input>
            <div class="el-form-item__error">{{ cuowuspan.phone }}</div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="10">
          <el-form-item style="text-align: right">
            <el-button
              type="warning"
              style="min-width: 110px; padding: 10px"
              round
              :disabled="disabled || shuru.phone.length != 11"
              @click="send"
              class="yzm"
              >{{ sends }}</el-button
            >
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <el-form-item></el-form-item>
        </el-col>
        <el-col :span="13">
          <el-form-item>
            <el-input
              placeholder="请输入验证码"
              @blur="Verificationa"
              v-model="shuru.Verification"
            ></el-input>
            <div class="el-form-item__error">{{ cuowuspan.Verification }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item style="margin: 24px auto 5px">
            <el-input
              placeholder="请输入您的密码"
              @blur="passa"
              v-model="shuru.pass"
              show-password
              maxlength="25"
              minlength='8'
            ></el-input>
            <div class="el-form-item__error">{{ cuowuspan.pass }}</div>
          </el-form-item>
          <ul class="m-mim">
            <li>
              <span :class="{ curr: /\d/.test(shuru.pass) }">●</span
              >密码中包含数字
            </li>
            <li>
              <span :class="{ curr: /[a-zA-Z]/g.test(shuru.pass) }">●</span
              >密码中包含字母
            </li>
            <li>
              <span
                :class="{
                  curr: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/.test(
                    shuru.pass
                  ),
                }"
                >●</span
              >8-25位密码且没有特殊字符
            </li>
          </ul>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item>
            <el-input
              placeholder="请再次确认您的密码"
              @blur="passworda"
              v-model="shuru.password"
              @keydown="security"
              show-password
              maxlength="25"
              minlength='8'
            ></el-input>
            <div class="el-form-item__error">{{ cuowuspan.password }}</div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item>
            <el-button
              :class="[isActived ? 'resetBtn' : '']"
              type="warning"
              round
              @click="forget"
              style="
                display: block;
                width: 136px;
                height: 40px;
                margin: 35px auto;
              "
              >完成</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 滑块参数
      nc_token: '',
      csessionid: '',
      sig: '',
      // 发送验证按按钮
      sendstime: 60,
      disabled: false,
      sends: '获取验证码',
      checked: false,
      Return: './../../static/images/icon/Return.png',
      // 输入的数据
      shuru: {
        phone: '',
        Verification: '',
        pass: '',
        password: ''
      },
      // 错误的提示信息
      cuowuspan: {
        phone: '',
        Verification: '',
        pass: '',
        password: ''
      },
      // 标识符
      phone: false,
      Verification: false,
      pass: false,
      password: false,
      yzmIcon: null
    }
  },
  computed: {
    isActived () {
      let reg1 = /\d/
      let reg2 = /[a-zA-Z]/g
      let reg3 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
      return !this.shuru.phone || this.cuowuspan.phone || this.shuru.Verification.length < 6 || this.cuowuspan.Verification || !reg1.test(this.shuru.pass) || !reg2.test(this.shuru.pass) || !reg3.test(this.shuru.pass) || this.shuru.password.length < 8 || this.cuowuspan.password
    }
  },
  methods: {
    send () {
      this.nc_token = this.$cookieStore.getCookie('nc_token')
      this.csessionid = this.$cookieStore.getCookie('csessionid')
      this.sig = this.$cookieStore.getCookie('sig')
      if (this.shuru.phone == '') {
        this.cuowuspan.phone = '请填写手机号'
        this.phone = true
      } else {
        this.http.yzpho(this.shuru.phone).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'false') {
              this.cuowuspan.phone = '您未注册，请返回点击微信注册！'
              this.phone = true
              return false
            }
          } else if (res.data.code == 500) {
            this.$notify({
              title: '请联系管理员咨询',
              type: 'warning'
            })
            return false
          }
          this.http
            .send(this.shuru.phone, this.nc_token, this.csessionid, this.sig)
            .then(res => {
              if (res.data.code == 200) {
                if (res.data.message == 'ok') {
                  this.$message({
                    message: '验证码已发送到您的手机，请注意查看',
                    type: 'success'
                  })
                  var that = this
                  var resend = setInterval(function () {
                    that.sendstime--
                    if (that.sendstime > 0) {
                      that.sends = that.sendstime + 's后重新获取'
                      that.disabled = true
                    } else {
                      clearInterval(resend)
                      that.sends = '获取验证码'
                      that.sendstime = 60
                      that.disabled = false
                    }
                  }, 1000)
                }
              } else if (res.data.code == 400) {
                if (res.data.message == 'failed,unable to get data') {
                  this.$message.error('不能获取到数据')
                } else if (res.data.message == 'failed,user phone invalid') {
                  this.$message.error('手机号无效')
                } else if (
                  res.data.message == 'failed,afs authenticate invalid'
                ) {
                  this.$message.error('滑块验证失败')
                }
              } else if (res.data.code == 500) {
                if (res.data.message == 'failed,please retry!') {
                  this.$message.error('验证码发送过于频繁，请稍后再试。，请重试！')
                }
              }
            })
        })
      }
    },
    security () {
      if (
        this.shuru.phone == '' ||
                this.shuru.Verification == '' ||
                this.shuru.pass == ''
      ) {
        return false
      } else if (
        this.phone == true ||
                this.Verification == true ||
                this.pass == true
      ) {
        return false
      } else if (this.shuru.password.length >= 7) {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    forget () {
      if (
        this.shuru.phone == '' ||
                this.shuru.Verification == '' ||
                this.shuru.pass == '' ||
                this.shuru.password == ''
      ) {
        return
      }
      if (
        this.phone == true ||
                this.Verification == true ||
                this.pass == true ||
                this.password == true
      ) {
        return
      }

      this.http
        .xgpass(this.shuru.phone, this.shuru.Verification, this.shuru.pass)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'ok') {
              this.$message({
                message: '修改成功，快去登录吧！',
                type: 'success'
              })
              this.$parent.$parent.bLogin1 = false
            }
          }
        })
        .catch(err => {
          this.$message.error('验证码填写错误')
        })
    },
    phonea () {
      if (this.shuru.phone == '') {
        this.phone = true
        this.cuowuspan.phone = '请填写手机号'
        this.yzmIcon = 'el-icon-error'
        return false
      } else if (this.shuru.phone) {
        var reg = /^1[2-9][0-9]\d{8}$/
        if (reg.test(this.shuru.phone)) {
          this.phone = false
          this.cuowuspan.phone = ''
          this.yzmIcon = 'el-icon-success'
        } else {
          this.phone = true
          this.cuowuspan.phone = '手机号格式有误'
          this.yzmIcon = 'el-icon-error'
          return false
        }
      }
    },
    Verificationa () {
      if (this.shuru.Verification == '') {
        this.cuowuspan.Verification = '请输入验证码'
        this.Verification = true
        return false
      } else if (this.shuru.Verification) {
        var reg = /^\d{6}$/
        if (reg.test(this.shuru.Verification)) {
          this.Verification = false
          this.cuowuspan.Verification = ''
        } else {
          this.Verification = true
          this.cuowuspan.Verification = '验证码格式有误'
          return false
        }
      }
    },
    passa () {
      this.passworda()
      if (this.shuru.pass == '') {
        this.cuowuspan.pass = '请输入密码'
        this.pass = true
        return false
      } else if (this.shuru.pass) {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
        if (reg.test(this.shuru.pass)) {
          this.cuowuspan.pass = ''
          this.pass = false
        } else {
          this.cuowuspan.pass = '密码格式有误'
          this.pass = true
          return false
        }
      }
    },
    passworda () {
      if (this.shuru.password == '') {
        this.cuowuspan.password = '请再次输入密码'
        this.password = true
        return false
      } else if (this.shuru.password == this.shuru.pass) {
        this.cuowuspan.password = ''
        this.password = false
      } else {
        this.cuowuspan.password = '两次密码输入不一致'
        this.password = true
        return false
      }
    }
  },
  beforeDestroy () {
    this.$cookieStore.delCookie('nc_token')
    this.$cookieStore.delCookie('csessionid')
    this.$cookieStore.delCookie('sig')
  }
}
</script>

<style lang="scss" scoped>
.resetBtn {
  color: #fff;
  background: #a6a9af;
}
</style>



// WEBPACK FOOTER //
// src/base/wjmm.vue